import React, {
  useState,
  useContext,
  useRef,
  useEffect,
  createRef,
} from "react";
import { useHistory } from "react-router-dom";

import AppContextObject from "../../../../common/context/common";
import { PublicContextInitiator } from "../../../apis/publicContextInitiator";
import proEdit from "../../../../assets/images/edit-profile.svg";
import imgInventory from "../../../../assets/images/blank-inventory-img.jpg";
import errorSVG from "../../../../assets/images/error.svg";
import closeCard from "../../../../assets/images/close-2.svg";
import faqArrow from "../../../../assets/images/faq-arrow.svg";
import Textfield from "../../../../components/formFields/textField/textField";
import Numberfield from "../../../../components/formFields/numberField";
import ConfirmDialog from "../../../../components/addon/confirmDialog/confirmDialog";
import SimpleReactValidator from "simple-react-validator";
import ImagePreview from "../../../../components/addon/imagePreview";
import BackendTopBar from "../components/backendTopBar";
import InventoryReport from "./inventoryReport";
import Loader from "../../../../components/addon/loader";
import Pagination from "../../../../components/addon/pagination";
import school from "../../brands/school";
import { objectDeepClone } from "../../../../service/helper";
import CustomSearchInput from "../../../../components/formFields/customSearchInput";
import CrImagePreview from "../../../../components/addon/crImagePreview";
import downloadIcon from "../../../../assets/images/download.svg";
import filterSvg from "../../../../assets/images/filter-svg.svg";
import filterArrowSvg from "../../../../assets/images/filter-arrow-svg.svg";

const CampaignCompetitionReportingView = (props) => {
  const context = useContext(AppContextObject);
  const history = useHistory();

  const [overlay, setOverlay] = useState(false);
  const [savingData, setSavingData] = useState(false);
  const [showSaveDataModal, setShowDataModal] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [ref, setRef] = useState();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [userLocation, setUserLocation] = useState<any>();
  const [showLocationAccessPopup, setShowLocationAccessPopup] = useState(false);
  const [inventoryList, setInventoryList] = useState([]);
  const [formData, setFormData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [schoolId, setSchoolId] = useState<any>();
  const [campaignId, setCampaignId] = useState<any>();
  const [schoolName, setSchoolName] = useState("");

  const [activeSetIndex, setActiveSetIndex] = useState(-1);
  const [activeInventoryIndex, setActiveInventoryIndex] = useState(-1);
  const [activeImageIndex, setActiveImageIndex] = useState(-1);
  const [showAllApproveModal, setShowAllApproveModal] = useState(false);
  const [showAllRejectModal, setShowAllRejectModal] = useState(false);
  const [showAllDeleteModal, setShowAllDeleteModal] = useState(false);
  const [showButtons, setShowButtons] = useState(false);

  const [multiSelectInventories, setMultiSelectInventories] = useState([]);

  const [salesViewData, setSalesViewData] = useState([]);

  const [clearSearchIcon, setClearSearchIcon] = useState(false);
  const [searchInpuOpen, setSearchInpuOpen] = useState(false);
  const [searchKeys, setSearchKeys] = useState("");
  const [debouncedSearchKeys, setDebouncedSearchKeys] = useState("");
  const [sortAlbumDataBy, setSortAlbumDataBy] = useState("school");
  const [location, setLocation] = useState("");
  const [selectedCities, setSelectedCities] = useState([]);
  const [openCityFilter, setOpenCityFilter] = useState(false);
  const [cityList, setCityList] = useState([]);
  const [cityWiseData, setCityWiseData] = useState([]);
  const [loadingCities, setLoadingCities] = useState(false);
  
  // Pagination state
  const [totalPage, setTotalPage] = useState([0]);
  const [currentPage, setCurrentpage] = useState(1);
  const [dataPerPage] = useState(25);

  let prevInventory = "";

  const handleChange = (e) => {
    const value = e === "" ? "" : e.target.value;
    setSearchKeys(value);
  };

  // Build query arguments for backend filtering (following campaign analysis pattern)
  const buildQueryArgs = () => {
    let queryArgs: any = {};
    
    // Add brandId from user context to ensure brand-specific filtering
    if (context.user?.brand) {
      queryArgs.brandId = context.user.brand.toString();
    }
    
    // Add search parameter - use debounced search keys
    if (debouncedSearchKeys && debouncedSearchKeys.trim()) {
      queryArgs.search = debouncedSearchKeys.trim();
    }
    
    // Add city filter
    if (selectedCities && selectedCities.length > 0) {
      if (selectedCities.length === 1) {
        queryArgs.city = selectedCities[0];
      } else {
        queryArgs.city = selectedCities;
      }
    }
    
    return queryArgs;
  };

  // Trigger filtering when search or filters change (following campaign analysis pattern)
  useEffect(() => {
    if (props.setShowSidemenu) {
      props.setShowSidemenu(true);
    }
    let state: any = history.location.state;
    if (
      context.user.role === "backendSales" ||
      context.user.role === "backendOperations" ||
      context.user.role === "backendAdmin" ||
      context.user.role.startsWith("brand")
    ) {
      if (
        history.location.search &&
        history.location.search.split("?").length > 1
      ) {
        let array = history.location.search.split("?");
        if (array && array.length > 1 && array[1] && array[1] !== "") {
          let data: any = array[1];
          if (data) {
            getAlbumViewForSales(data);
          }
        }
      } else if (state.albumId) {
        getAlbumViewForSales(state.albumId);
      }
    }
  }, [debouncedSearchKeys, selectedCities, currentPage]);

  // Reset to page 1 when filters change (following campaign analysis pattern)
  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentpage(1);
    }
  }, [debouncedSearchKeys, selectedCities]);

  // Fetch city-wise data when component mounts
  useEffect(() => {
    getCityWiseData();
  }, []);

  // Debounced search effect - triggers search after 500ms delay when 3+ characters
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (searchKeys.length >= 3 || searchKeys === "") {
        setDebouncedSearchKeys(searchKeys);
        setCurrentpage(1);
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchKeys]);

  // Close filter dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openCityFilter && !event.target.closest('.filterbox')) {
        setOpenCityFilter(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openCityFilter]);

  const getInventoryReportData = async (school_id, campaign_id) => {
    setIsLoading(true);
    let resp = await context.apis[
      context.user.role
    ].getAllCampaignReportingSetByCampaign(
      context.validator,
      { campaignId: campaign_id, schoolId: school_id },
      {}
    );
    if (resp && resp.done) {
      setFormData([...resp.response.rows]);
      setIsLoading(false);
    }
  };

  const handleCityFilter = (city) => {
    // For city, use multiple selection - toggle the selected city (following campaign analysis pattern)
    let array = [...selectedCities];
    if (array.includes(city)) {
      array.splice(array.indexOf(city), 1); // Remove if already selected
    } else {
      array.push(city); // Add to selection
    }
    setSelectedCities([...array]);
  };

  const clearCityFilter = () => {
    setSelectedCities([]);
  };

  const clearSearch = () => {
    setSearchKeys("");
    setDebouncedSearchKeys("");
    setCurrentpage(1);
  };

  // Pagination handlers
  const onPageChange = (page) => {
    setCurrentpage(page);
  };

  const onNextClick = () => {
    setCurrentpage(currentPage + 1);
  };

  const onPrevClick = () => {
    setCurrentpage(currentPage - 1);
  };

  const getCityWiseData = async () => {
    setLoadingCities(true);
    try {
      // Determine if this is a ZEE campaign
      const ZEE_BRAND_ID = "695b91aacd5a37000777f98e";
      const ZEE_CAMPAIGN_ID = "zee_campaign_s1";
      const campaignId = history.location.search?.split("?")[1] || "";
      const isZeeCampaign = campaignId === ZEE_CAMPAIGN_ID || context.user?.brand === ZEE_BRAND_ID;
      
      // Use ZEE-specific APIs for ZEE campaigns, HP APIs for HP campaigns
      let statesResp;
      if (isZeeCampaign && context.apis.public.getZeeStatesByCountryRegion) {
        statesResp = await context.apis.public.getZeeStatesByCountryRegion(
          context.validator, 
          {}, 
          {}
        );
      } else {
        statesResp = await context.apis.public.getHpStatesByCountryRegion(
          context.validator, 
          {}, 
          {}
        );
      }
      
      if (statesResp && statesResp.done && statesResp.response) {
        let allStates = [];
        
        // Extract states from response - using same logic as dashboard
        if (statesResp && statesResp.done) {
          statesResp?.response?.rows?.forEach(row => {
            if (row.states && Array.isArray(row.states)) {
              allStates = [...allStates, ...row.states];
            }
          });
          
          // Remove duplicates and sort like dashboard
          allStates = allStates.filter((state, index) => allStates.indexOf(state) === index).sort((a, b) => {
            return a.toLowerCase() > b.toLowerCase() ? 1 : -1
          });
        }
        
        // If no states found, fallback to pincode API
        if (allStates.length === 0) {
          const citiesResp = await context.apis.public.getCitiesByCountryRegion(
            context.validator, 
            { countryRegion: [] }, 
            {}
          );
          
          if (citiesResp && citiesResp.done && citiesResp.response.rows) {
            let cities = [];
            citiesResp.response.rows.forEach(row => {
              if (row.cities && Array.isArray(row.cities)) {
                row.cities.forEach(city => {
                  if (!cities.includes(city)) {
                    cities.push(city);
                  }
                });
              }
            });
            
            const sortedCities = cities.sort((a, b) => a.localeCompare(b));
            setCityList(sortedCities);
            
            const cityData = sortedCities.map(city => ({
              name: city,
              status: "Active"
            }));
            
            setCityWiseData(cityData);
            return;
          }
        }
        
        // Now get cities for all states - use ZEE APIs for ZEE campaigns
        let allCities = [];
        
        if (allStates.length > 0) {
          try {
            let citiesResp;
            if (isZeeCampaign && context.apis.public.getZeeCitiesByState) {
              citiesResp = await context.apis.public.getZeeCitiesByState(
                context.validator, 
                { states: allStates }, 
                {}
              );
            } else {
              citiesResp = await context.apis.public.getHpCitiesByState(
                context.validator, 
                { states: allStates }, 
                {}
              );
            }
            
            if (citiesResp && citiesResp.done) {
              citiesResp?.response?.rows?.forEach(row => {
                if (row.cities && row.cities.length > 0) {
                  row.cities.forEach(cityObj => {
                    if (cityObj.city && !allCities.find(data => data.toLowerCase() === cityObj.city.toLowerCase())) {
                      allCities.push(cityObj.city);
                    }
                  });
                }
              });
              
              // Sort cities like dashboard
              allCities = allCities.sort((a, b) => {
                return a.toLowerCase() > b.toLowerCase() ? 1 : -1;
              });
            }
          } catch (error) {
            console.error(`Error fetching cities:`, error);
          }
        }
        
        const sortedCities = allCities.sort((a, b) => a.localeCompare(b));
        setCityList(sortedCities);
        
        // Create city data without school counts
        const cityData = sortedCities.map(city => ({
          name: city,
          status: "Active"
        }));
        
        setCityWiseData(cityData);
      }
    } catch (error) {
      console.error("Error fetching city-wise data:", error);
      setCityWiseData([]);
      setCityList([]);
    } finally {
      setLoadingCities(false);
    }
  };
  const handleCityWiseDownload = async (cityName) => {
      
      // Determine if this is a ZEE campaign
      const ZEE_BRAND_ID = "695b91aacd5a37000777f98e";
      const ZEE_CAMPAIGN_ID = "zee_campaign_s1";
      const campaignId = history.location.search?.split("?")[1] || "";
      const isZeeCampaign = campaignId === ZEE_CAMPAIGN_ID || context.user?.brand === ZEE_BRAND_ID;
      const brandId = context.user?.brand || (isZeeCampaign ? ZEE_BRAND_ID : null);
      
      
      // Pass brandId to backend so it can use the correct collection
      let resp = await context.apis[context.user.role].triggerPendingPDFGenerationCityWise(
        context.validator, 
        {
          cityName: cityName,
          brandId: brandId // Pass brandId so backend can detect ZEE
        }
      );
      
      if(resp.signedUrl)
      {
        window.open(resp.signedUrl)
      }
      else
      {
        alert("No Records Found for this city")
      }
       
  };

  const handleSchoolDownload = async (schoolName, schoolId=1019) => {
      // Determine if this is a ZEE campaign
      const ZEE_BRAND_ID = "695b91aacd5a37000777f98e";
      const ZEE_CAMPAIGN_ID = "zee_campaign_s1";
      const campaignId = history.location.search?.split("?")[1] || "";
      const isZeeCampaign = campaignId === ZEE_CAMPAIGN_ID || context.user?.brand === ZEE_BRAND_ID;
      const brandId = context.user?.brand || (isZeeCampaign ? ZEE_BRAND_ID : null);
      
      const options = {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                schoolId: schoolId,
                brandId: brandId // Pass brandId so backend can detect ZEE
            })
        }
        fetch('/api/downloadCampaignReportingDocBySchoolId', options)
        .then(response => response.json())
        .then(data => {
            console.log("download Campaign PDF Downloading", data)
            if (data && data.result && data.result.pdfData) {
                // setDownloadSchoolLoading(false);
                // let file = data.result.file.data;
                // downloadFile(file, data.result.filename)
                window.open(data.result.pdfData.image)
            } else {
                alert("PDF not available for this school")
            }
        })
        .catch(err => console.error("downloadCampaignReportingDocBySchoolId", err))
  };

  useEffect(() => {
    if (context.user.role === "backendOperations" && salesViewData.length > 0) {
      getInventoryReportData(salesViewData[0]?.schoolId, "");
    }
  }, [salesViewData]);

  const getAlbumViewForSales = async (_id) => {
  setIsLoading(true);
 try {
      // Build query parameters for backend filtering (following campaign analysis pattern)
      const args = buildQueryArgs();
      
      // Determine if this is a ZEE campaign and use appropriate API
      const ZEE_BRAND_ID = "695b91aacd5a37000777f98e";
      const ZEE_CAMPAIGN_ID = "zee_campaign_s1";
      const isZeeCampaign = _id === ZEE_CAMPAIGN_ID || context.user?.brand === ZEE_BRAND_ID;
      
      // Call the appropriate API - use getAllZeeSchoolImages for ZEE, getAllSchoolImages for HP
      let response;
      if (isZeeCampaign && context.apis.public.getAllZeeSchoolImages) {
        response = await context.apis.public.getAllZeeSchoolImages(
          context.validator,
          args,
          { page: currentPage, limit: dataPerPage, withCount: true }
        );
      } else {
        response = await context.apis.brandManager.getAllSchoolImages(
          context.validator,
          args,
          { page: currentPage, limit: dataPerPage, withCount: true }
        );
      }
      
      if (response && response.done && response.response && response.response.rows) {
        // Transform the API response to match the expected format
        const transformedData = response.response.rows.map((schoolData, index) => {
          // Extract school name from school_info or use school_code as fallback
          const schoolName = schoolData.school_info?.name || `School ${schoolData.school_code}`;
          const schoolLocation = schoolData.school_info?.city && schoolData.school_info?.state 
            ? `${schoolData.school_info.city}, ${schoolData.school_info.state}`
            : "Unknown Location";

        const transformedImages = (schoolData.images_path || []).map((imagePath, imgIndex) => {
          const isNoticeBoard = imagePath.toLowerCase().includes("nb");
          const fullImagePath = imagePath.startsWith("http")
            ? imagePath
            : `https://hp-wisr-report-prod.s3.ap-south-1.amazonaws.com/${imagePath}`;

          return {
            _id: `img_${schoolData.school_code}_${imgIndex}`,
            image: fullImagePath,
            imageMt: fullImagePath,
            status: "approved",
            approvalStatus: "approved",
            uploadedBy: "system",
            uploadedOn: schoolData.createdOn || new Date().toISOString(),
            description: isNoticeBoard ? "Notice Board display" : "School activity image",
            placementName: isNoticeBoard ? "Notice Board" : "Other",
          };
        });

        // Sort: Notice Board images first, then by latest date
        transformedImages.sort((a, b) => {
          // First priority: Notice Board images
          if (a.placementName === "Notice Board" && b.placementName !== "Notice Board") return -1;
          if (a.placementName !== "Notice Board" && b.placementName === "Notice Board") return 1;
          
          // Second priority: Latest images first
          const dateA = new Date(a.uploadedOn).getTime();
          const dateB = new Date(b.uploadedOn).getTime();
          return dateB - dateA; // Latest first
        });

        // Find the latest upload date for this school
        const latestUploadDate = transformedImages.length > 0 
          ? Math.max(...transformedImages.map(img => new Date(img.uploadedOn).getTime()))
          : new Date(schoolData.createdOn || new Date()).getTime();

        return {
          _id: schoolData._id,
          albumTitle: "HP Smartchamps S1 Campaign Album",
          location: schoolLocation,
          schoolId: schoolData.school_code,
          schoolName,
          name: "HP Smartchamps S1",
          inventoryId: schoolData._id,
          images: transformedImages,
          isPDFCreated: schoolData.isPDFcreated,
        };
      });

      // Sort schools by their latest upload date (newest first)
      transformedData.sort((a, b) => {
        return b.latestUploadDate - a.latestUploadDate; // Latest schools first
      });

      console.log("Transformed Sales View Data:", transformedData);
      setSalesViewData(transformedData);
      setLocation(transformedData[0]?.location || "");

      const totalCount = response.response.count || 0;
      const totalPages = Math.ceil(totalCount / dataPerPage);
      setTotalPage(Array.from({ length: totalPages }, (_, i) => i));
    } else {
      setSalesViewData([]);
      setLocation("");
      setTotalPage([0]);
    }
  } catch (error) {
    console.error("Error fetching school images data:", error);
    setSalesViewData([]);
    setLocation("");
    setTotalPage([0]);
  }

  setIsLoading(false);
};


  return (
    <>
      <div className={`ovelap ${overlay ? "active" : ""}`}></div>
      <div className="col-xl-10 col-lg-12 col-md-12 col-xs-12">
        <div className="rightPart noBack">
          <div className="row">
            <BackendTopBar
              from={context.user.role === "backendFOS" && "campaignReporting"}
              redirectPage={false}
            />
            {isLoading ? (
              <Loader />
            ) : (
              <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12 mb-10 mt-20">
                <h2 className="htx2 clearfix mb-20">
                  Reporting and Monitoring
                </h2>
                <div
                  style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                  <ul className={`tabsinventory`}>
                                         <li onClick={() => setSortAlbumDataBy("school")}>
                       <a
                         href="javascript:void(0);"
                         className={sortAlbumDataBy === "school" ? "active" : ""}
                       >
                         Schools
                       </a>
                     </li>

                     <li onClick={() => setSortAlbumDataBy("inventory")}>
                        <a
                          href="javascript:void(0);"
                          className={
                            sortAlbumDataBy === "inventory" ? "active" : ""
                          }
                        >
                         Cities
                        </a>
                      </li>
                    
                  </ul>
                  <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                    {sortAlbumDataBy === "school" && (
                      <div className="filterbox" style={{ margin: "0", position: "relative" }}>
                        <a 
                          href="javascript:void(0);" 
                          className="filterDrop" 
                          onClick={() => setOpenCityFilter(!openCityFilter)}
                          style={{ 
                            display: "flex", 
                            alignItems: "center", 
                            gap: "8px",
                            padding: "8px 12px",
                            borderRadius: "4px",
                            border: "1px solid #ddd",
                            backgroundColor: "#fff",
                            textDecoration: "none",
                            color: "#333",
                            fontSize: "14px"
                          }}
                        >
                                                     <img src={filterSvg} style={{ width: "16px", height: "16px" }} />
                           <span>
                             Filter by City
                             {selectedCities.length > 0 && ` (${selectedCities.length})`}
                           </span>
                           <img src={filterArrowSvg} style={{ width: "12px", height: "12px" }} />
                        </a>
                        {openCityFilter && (
                          <div 
                            className="filterDropDown open"
                            style={{
                              position: "absolute",
                              top: "100%",
                              right: "0",
                              zIndex: 1000,
                              backgroundColor: "#fff",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                              minWidth: "200px",
                              marginTop: "5px"
                            }}
                          >
                            <div className="filterDropHead" style={{ padding: "12px 16px", borderBottom: "1px solid #eee" }}>
                              <h2 style={{ margin: "0", fontSize: "16px", fontWeight: "600" }}>
                                Filter by City 
                                <a 
                                  href="javascript:void(0);" 
                                  className="viewwLink" 
                                  onClick={clearCityFilter}
                                  style={{ 
                                    float: "right", 
                                    color: "#007bff", 
                                    textDecoration: "none",
                                    fontSize: "14px"
                                  }}
                                >
                                  Clear All
                                </a>
                              </h2>
                            </div>
                            <div className="filterDropBody" style={{ padding: "12px 16px" }}>
                              <div className="filterDropClose open">
                                <div className="filtercheckbox">
                                  {cityList.map((city, index) => (
                                                                         <div className="checkbox fnone" key={index} style={{ marginBottom: "8px" }}>
                                       <input 
                                         type="checkbox" 
                                         id={city} 
                                         checked={selectedCities.includes(city)}
                                         style={{ marginRight: "8px" }}
                                       />
                                      <label 
                                        htmlFor={city} 
                                        onClick={() => handleCityFilter(city)}
                                        style={{ 
                                          cursor: "pointer",
                                          fontSize: "14px",
                                          color: "#333"
                                        }}
                                      >
                                        {city}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    {sortAlbumDataBy === "school" && (
                  <CustomSearchInput
                    searchInpuOpen={searchInpuOpen}
                    setSearchInpuOpen={setSearchInpuOpen}
                    clearSearchIcon={clearSearchIcon}
                    setClearSearchIcon={setClearSearchIcon}
                    handleChange={handleChange}
                    searchKeys={searchKeys}
                    align="right"
                  />
                    )}
                  </div>
                </div>
                 <div className="faq-view">
                   <div className="faq-tabs-list">
                     {sortAlbumDataBy === "school" ? (
                       // Show schools view
                       salesViewData.length > 0 &&
                        salesViewData
                          .filter(item => selectedCities.length === 0 || selectedCities.some(city => item.location?.includes(city)))
                          .map((item, inventoryIndex) => {
                         if (prevInventory === item._id) {
                           item._id = "";
                         } else {
                           prevInventory = item._id;
                         }
                         return (
                           <div key={inventoryIndex} style={{ position: "relative" }}>
                             {/* Download icon for each school */}
                             <div style={{
                               position: "absolute",
                                top: "0px",
                               right: "20px",
                                zIndex: 10,
                                cursor: "pointer"
                             }}>
                               {/* Show download icon if PDF exists OR if school has images (for on-the-fly generation) */}
                               {(item.isPDFCreated || (item.images && item.images.length > 0)) && (
                                <img 
                                  src={downloadIcon}
                                  alt="Download PDF"
                                  onClick={() => handleSchoolDownload(item.schoolName, item.schoolId)}
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    cursor: "pointer"
                                  }}
                                  title="Download PDF"
                                />
                              )}
                             </div>
                             
                             
                             <InventoryReport
                               ref={ref}
                               inventoryIndex={inventoryIndex}
                               inventory={item}
                               formData={formData}
                               setFormData={setFormData}
                               schoolId={schoolId}
                               campaignId={campaignId}
                               setRefetch={setRefetch}
                               refetch={refetch}
                               setShowButtons={setShowButtons}
                               showButtons={showButtons}
                               setActiveSetindex={setActiveSetIndex}
                               setActiveImageIndex={setActiveImageIndex}
                               setActiveInventoryIndex={setActiveInventoryIndex}
                               activeSetIndex={activeSetIndex}
                               activeInventoryIndex={activeInventoryIndex}
                               activeImageIndex={activeImageIndex}
                               multiSelectInventories={multiSelectInventories}
                               setMultiSelectInventories={
                                 setMultiSelectInventories
                               }
                               groupBy={sortAlbumDataBy}
                               view={"campaignReportView"}
                               campaignLocation={location}
                             />
                             {salesViewData.length - 1 !== inventoryIndex && (
                               <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12 mt-20 mb-20">
                                 <div className="line-full"></div>
                               </div>
                             )}
                           </div>
                         );
                       })
                     ) : (
                       // Show city-wise download PDF view
                       <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12">
                          <div className="inventory-tableTabs">
                            <div className="table-container table-inventory mt-10">
                              {loadingCities ? (
                                <div style={{ textAlign: "center", padding: "40px" }}>
                                  <div className="loader-imgupload"></div>
                                  <p style={{ marginTop: "10px", color: "#666" }}>Loading cities data...</p>
                               </div>
                              ) : cityWiseData.length === 0 ? (
                                <div style={{ textAlign: "center", padding: "40px" }}>
                                  <p style={{ color: "#666" }}>No cities data available</p>
                             </div>
                              ) : (
                                <table className="table">
                                  <thead>
                                    <tr>
                                      <th scope="col" style={{ width: "10%", textAlign: "center" }}>SL No</th>
                                      <th scope="col" style={{ width: "70%", textAlign: "left" }}>City Name</th>
                                      <th scope="col" style={{ width: "20%", textAlign: "center" }}>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {cityWiseData.map((city, index) => (
                                      <tr key={index}>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>{index + 1}</td>
                                        <td style={{ textAlign: "left", verticalAlign: "middle" }}>
                                          <div className="schoolNameTable">
                                            <h4 style={{ margin: "0", fontSize: "16px", fontWeight: "500" }}>
                                              {city.name.split(' ').map(word => 
                                                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                                              ).join(' ')}
                                            </h4>
                               </div>
                                        </td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                          <img 
                                            src={downloadIcon}
                                            alt="Download PDF"
                                            onClick={() => handleCityWiseDownload(city.name)}
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                 cursor: "pointer",
                                              transition: "transform 0.2s ease"
                                            }}
                                            title={`Download PDF for ${city.name}`}
                                            onMouseEnter={(e) => {
                                              const target = e.target as HTMLImageElement;
                                              target.style.transform = "scale(1.1)";
                                            }}
                                            onMouseLeave={(e) => {
                                              const target = e.target as HTMLImageElement;
                                              target.style.transform = "scale(1)";
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              )}
                           </div>
                         </div>
                       </div>
                     )}
                   </div>
                 </div>
               </div>
             )}
             
             {/* Pagination - Hide when Cities tab is active */}
             {sortAlbumDataBy !== "inventory" && (
               <div className="col-lg-12 col-md-12 col-xs-12 p-r">
                 {totalPage.length > 1 && (
                   <Pagination
                     currentPage={currentPage}
                     totalPage={totalPage}
                     onPageChange={onPageChange}
                     onNextClick={onNextClick}
                     onPrevClick={onPrevClick}
                     loading={isLoading}
                   />
                 )}
               </div>
             )}
           </div>
         </div>
       </div>
     </>
   );
 };

export default CampaignCompetitionReportingView; 